export default __webpack_public_path__ + "static/306-16a604728e8c500a93266a97491899f8.gif";